<template>
	<div class="control">
		<template>
			<div class="form-group input-group">
				<input :id="'form-' + parent.specification" class="form-control" type="text" v-model="query" v-bind:placeholder="control.placeholder" v-on:keyup.enter="updateFilters" />
				<div class="input-group-append">
					<button class="btn btn-outline-secondary" 
							type="button" 
							v-on:click="updateFilters"
							:disabled="!query || query.trim() === ''">
						<span class="icon-search"></span>
						<span class="sr-only">Search</span>
					</button>
					<button class="btn btn-plain"
							v-if="query && query.trim() !== ''"
							v-on:click="clearSearch()">
						Clear
					</button>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'parent'],
		data: function () {
			return {
				query: this.control.defaultValue,
			}
		},
		mounted: function () {
			let initialData = this.$store.state.listing.specification[this.parent.specification];
			if (initialData !== '') {
				this.query = initialData;
			}
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.query = this.parent.defaultValue;
				}
			});

			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					if (state.listing.specification.StateCode !== null && this.parent.specification === 'Zipcode') {
						this.query = this.parent.defaultValue;
					}
				}
			});
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilters() {
				// if hitting api on each checkmark change
				//if (this.query === null) {
					//this.query = '';
				//}
                this.updateSpecification({ key: this.parent.specification, value: encodeURIComponent(this.query) });

			},
			clearSearch() {
				this.query = '';
				this.updateFilters();
            }
		}
	}
</script>